<template>
  <div>
    <!-- Modal Assinatura-->
    <div class="modal fade" id="responseModal" tabindex="-1" role="dialog" aria-labelledby="responseModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="responseModalLabel">
              Resposta do Assistente IA
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-html="gptResponse"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
    <base-crud 
    crudName="GPT Logs" 
    newText="" 
    :table="table" 
    :columns="columns" 
    :options="options"
    :endPoint="endPoint" 
    :enableAdd="false" 
    :enableEdit="false" 
    :enableDelete="false" 
    :enableView="false"
    :extra="extra"
    @showGptResponse="showGptResponse"
    >
  </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "gptLogs",
      pages: [],
      gptResponse: '',
      url: "",
      columns: ["id", "tenant", "user", "userPrompt", "actions"],
      tableData: ["id", "tenant", "user", "userPrompt"],
      options: {
        filterable: ["id", "tenant", "user", "userPrompt"],
        filterByColumn: true,
        sortable: ["id", "tenant", "user", "userPrompt"],
        templates: {
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          tenant: "Ambiente",
          user: "Usuário",
          userPrompt: "Solicitação",
          actions: "Ações"
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http
            .get(this.url + '?' + query, requestData)
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        }
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-info fa fa-eye",
          style: "",
          title: "Visualizar Resposta IA",
          name: "showGptResponse",
          icon: ""
        },
      ],
      endPoint: "gptLogs/"
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "ID",
        tenant: "Ambiente",
        user: "Usuário",
        userPrompt: "Solicitação",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
    //Formata a string colocando paragrafos para ficar mais legível
    splitAndWrap(text) {
    var parts = text.split('.');
    
    var wrappedText = [];
    
    parts.forEach(function(part, index) {
      var isLastPart = index === parts.length - 1;
    
      if (isLastPart) {
          wrappedText.push('<p>' + part.trim() + '</p>');
      } else {
          wrappedText.push('<p>' + part.trim() + '.</p>');
      }    
    });
    
    var string = wrappedText.join(''); 

    return string.slice(0, -1);
    },
    showGptResponse(props){
      this.gptResponse = this.splitAndWrap(props.row.gptResponse)
      $("#responseModal").modal({
        show: true,
      });
    }
  },
  components: {
    BaseCrud,
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/gptLogs/Crud.vue